"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _elementUi = require("element-ui");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'GOption',
  extends: _elementUi.Option,
  props: {
    data: {
      type: Object,
      required: true
    },
    /** 格式化联想控件显示，可使用 {{}} 表达式字符串或 function，接收参数 record */
    displayFormat: Function
  },
  computed: {
    currentLabel: function currentLabel() {
      if (typeof this.displayFormat === 'function') {
        return this.displayFormat(this.data);
      }
      return this.label || (this.isObject ? '' : this.value);
    }
  }
};